






































































import {Component, Prop, Vue} from 'vue-property-decorator'
import {$, ID, successAndPush} from 'simpli-web-sdk'
import {AppConfig} from '@/config/app.config'
import _ from 'lodash'
import EmailAuditoria from '@/model/resource/EmailAuditoria'
import {ItrackCollection} from '@/helpers'

const metaInfo = () => ({
  title: $.t('view.persist.auditEmailPersist.title'),
})

@Component({
  metaInfo,
})
export default class AuditEmailPersistView extends Vue {
  @Prop({type: [String, Number]}) id?: ID

  AppConfig = AppConfig
  allType = ItrackCollection.allEmailNivel

  listToPersist: EmailAuditoria[] = []

  persistThrottled = _.throttle(() => this.persist(), 7000)

  created() {
    this.$set(this.listToPersist, 0, new EmailAuditoria())
  }

  async mounted() {
    await this.allType.query()
    if (this.id) await this.listToPersist[0].getEmailAuditoria(this.id)
    $.await.done('getAuditEmail')
  }

  addItem() {
    this.listToPersist.push(new EmailAuditoria())
  }

  removeItem(item: EmailAuditoria) {
    const index = this.listToPersist.indexOf(item)
    if (index > -1) {
      this.listToPersist.splice(index, 1)
      this.$forceUpdate()
    }
  }

  async persist() {
    await EmailAuditoria.persistLoteEmailAuditoria(this.listToPersist)
    successAndPush('system.success.persist', '/manage/audit-email/list')
  }

}
